import { Component, ViewEncapsulation } from '@angular/core';
import { Config } from '@shared/config';
import { AmbassadorPin, EventPin, MapPin, ProjectPin } from '@shared/interfaces/pins.interface';
import { Response } from '@shared/models/response.model';
import * as Leaflet from 'leaflet';
import OpenStreetMapBaseComponent from '@layouts/default/components/open-street-map-base/open-street-map-base.component';

@Component({
    selector: 'app-homepage-filtered-map',
    templateUrl: './homepage-filtered-map.component.html',
    styleUrls: [
        '../open-street-map-base/open-street-map-base.component.scss',
        './homepage-filtered-map.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export class HomepageFilteredMapComponent extends OpenStreetMapBaseComponent {
    MARKER_ICON_SIZE: number = 44;

    public selectedFilter = 'event'
    public loadingData: boolean = true;
    public pins: AmbassadorPin[] | EventPin[] | ProjectPin[] = [];

    afterClusterLoad() {
        this.loadPins();
    }

    mapOptions(): Leaflet.MapOptions {
        return {
            layers: Config.OPEN_STREET_MAP_LAYERS,
            zoom: 2,
            center: Config.MAP_CENTRE_POINT as Leaflet.LatLngLiteral,
            gestureHandling: true
        } as Leaflet.MapOptions
    }

    changeSelectedFilter(filter: string) {
        if (this.loadingData || this.selectedFilter === filter) {
            return;
        }

        this.selectedFilter = filter;
        this.loadPins();
    }

    loadPins(): void {
        this.loadingData = true;
        this.pins = [];

        const apiCallback = function (response: Response<MapPin[]>) {
            // We have to filter API result as some pins have invalid location data
            const filteredPins = response.data.filter((pin: MapPin) => { return !(isNaN(Number(pin.latitude)) || isNaN(Number(pin.longitude))) });
            filteredPins.forEach((pin: MapPin) => { pin.markerType = this.selectedFilter })
            this.pins = this.openStreetMapService.randomizeDuplicatePositions(filteredPins);
            this.loadingData = false;
            this.refreshMarkersList();
            this.map.setView(this.mapOptions().center, this.mapOptions().zoom);
        }.bind(this);

        switch (this.selectedFilter) {
            case 'event':
                this.pinsService.getEventPins().subscribe({ next: apiCallback });
                break;
            case 'project':
                this.pinsService.getProjectPins().subscribe({ next: apiCallback });
                break;
            case 'ambassador':
                this.pinsService.getAmbassadorPins().subscribe({ next: apiCallback });
                break;
        }
    }

    refreshMarkersList(): void {
        this.markersCluster.clearLayers();

        if (this.pins.length == 0) {
            return;
        }

        const that = this;

        const markers = this.pins.map((pin: MapPin): Leaflet.Marker => {
            // @ts-ignore
            const marker = Leaflet.marker([pin.latitude, pin.longitude], {
                icon: Leaflet.divIcon({
                    className: 'osm-map-marker project-marker',
                    iconSize: [that.MARKER_ICON_WIDTH, that.MARKER_ICON_HEIGHT],
                    iconAnchor: [that.MARKER_ICON_WIDTH / 2, that.MARKER_ICON_HEIGHT]
                })
            });

            this.addMarkerEvents(marker, pin)

            return marker;
        });

        this.markersCluster.addLayers(markers);
    }
}
